var map = {
	"./allergy-dairy.png": "5db1",
	"./allergy-egg.png": "39a3",
	"./allergy-fish.png": "5142",
	"./allergy-gluten.png": "1363",
	"./allergy-peanut.png": "1b588",
	"./allergy-shellfish.png": "8407",
	"./allergy-soy.png": "4596",
	"./allergy-tree-nuts.png": "aed2",
	"./allergy-wheat.png": "3a61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcfc";